<template>
  <div class="users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a">
    <div class="myusers f-s-s f-d-c w-100 pt-5 pr-5 pl-5 pb-2">
      <div class="userProfile f-c-c f-d-c w-100 h-100 pl-3">
        <div class="header f-c-s w-100 mb-4">
          <div class="userPhoto f-c-c">
            <img class="pic f-c-c" :src="cropped" />
            <input
              id="getUserPhoto"
              type="file"
              accept="image/gif, image/jpeg, image/png"
              @change="croppie"
            />
            <b-img
              @click.prevent="editUserPhotoFunc()"
              class="edit"
              :src="require(`@/assets/images/gap/edit-icon.svg`)"
            ></b-img>
          </div>
          <div class="headerTitlef-c-c">
            {{ headerTitle }}
          </div>
        </div>
        <div class="divider f-c-c w-100"></div>
        <div class="editTitle f-c-s w-100 mb-4">
          <b-img
            :src="require(`@/assets/images/profile/edit-icon.svg`)"
          ></b-img>
          <div class="text f-c-c">ویرایش مشخصات</div>
        </div>
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">نام</div>
          <div class="fields f-c-s">
            <input type="text" v-model="name" />
          </div>
        </div>
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">نام خانوادگی</div>
          <div class="fields f-c-s">
            <input type="text" v-model="family" />
          </div>
        </div>
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">موبایل</div>
          <div class="fields f-c-s">
            <!-- <input type="number" v-model="mobile" /> -->
            <div class="input">{{ mobile }}</div>
          </div>
        </div>
        <!-- <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">ایمیل</div>
          <div class="fields f-c-s">
            <input type="email" v-model="email" />
            <div class="input">{{ email }}</div>
          </div>
        </div> -->
        <!-- <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">سازمان</div>
          <div class="fields f-c-s">
            <div class="input">{{ org }}</div>
          </div>
        </div> -->
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">رمز عبور</div>
          <div class="fields f-c-s">
            <div class="passSection f-c-c">
              <input
                :type="isShowPass ? 'text' : 'password'"
                v-model="password"
              />
              <b-img
                v-if="isShowPass"
                class="cp"
                @click.prevent="showPasswordFunc()"
                :src="require(`@/assets/images/profile/eyes-open.svg`)"
              ></b-img>
              <b-img
                v-else
                class="cp"
                @click.prevent="showPasswordFunc()"
                :src="require(`@/assets/images/profile/eyes-close.svg`)"
              ></b-img>
            </div>
          </div>
        </div>
        <div class="row f-c-s w-100 mb-5">
          <div class="label f-c-s">تکرار رمز عبور</div>
          <div class="fields f-c-s">
            <div class="passSection f-c-c">
              <input
                :type="isShowRpass ? 'text' : 'password'"
                v-model="rpassword"
              />
              <b-img
                v-if="isShowRpass"
                class="cp"
                @click.prevent="showRpasswordFunc()"
                :src="require(`@/assets/images/profile/eyes-open.svg`)"
              ></b-img>
              <b-img
                v-else
                class="cp"
                @click.prevent="showRpasswordFunc()"
                :src="require(`@/assets/images/profile/eyes-close.svg`)"
              ></b-img>
            </div>
          </div>
        </div>
        <!-- <div class="row f-c-s w-100 mb-5">
          <div class="label f-c-s">جنسیت</div>
          <div class="fields f-c-s">
            <select class="gender" v-model="gender">
              <option value="male">مرد</option>
              <option value="female">زن</option>
            </select>
          </div>
        </div> -->
        <div v-if="user.permissions.edit_profile" class="row f-c-s w-100 mb-5">
          <div class="label f-c-s"></div>
          <div class="fields f-c-s">
            <div class="editUserProfile f-c-c" @click="editUserProfileFunc()">
              ویرایش
            </div>
          </div>
        </div>
        <div v-if="user.is_organ == 'yes'" class="w-100 f-c-s f-d-c">
          <div class="editTitle f-c-s w-100 mb-4">
            <b-img :src="require(`@/assets/images/profile/mygroup.svg`)"></b-img>
            <div class="text f-c-c">سازمان های من</div>
          </div>
          <div
            v-if="user.permissions.profile_add_organ"
            class="addGroupSec f-c-e w-100 mb-3"
          >
            <div @click.prevent="addGroupFunc()" class="addGroup f-c-c">
              <span class="plus ml-2">+</span>
              <div class="text f-c-c">افزودن سازمان</div>
            </div>
          </div>
          <div class="mygroupTable f-c-c f-d-c w-100 mb-5">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s">عنوان</div>
              <div class="headerItem f-c-s">وضعیت</div>
            </div>
            <div
              v-if="itemsForList4.length"
              class="tableContent f-c-c f-d-c w-100"
            >
              <div
                v-for="(v, i) in itemsForList4"
                :key="i"
                class="tableRow f-c-s w-100"
              >
                <div class="tableItem f-c-c">{{ v.row }}</div>
                <div class="tableItem f-c-s">
                  {{ v ? v.title : "-" }}
                </div>
                <div class="tableItem f-c-s">
                  {{ v ? v.status : "-" }}
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
              گروهی وجود ندارد.
            </div>
            <div class="paginationSection f-c-c w-100">
              <b-pagination
                v-model="currentPage4"
                :total-rows="rows4"
                :per-page="perPage4"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
          <div
            v-if="mobileMyGroup.length"
            class="mobileUserTable f-c-s f-d-c w-100 mb-3"
          >
            <div
              v-for="(v, i) in mobileMyGroup"
              :key="i"
              class="tableItem f-c-s f-d-c w-100 mb-3"
            >
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">عنوان :</div>
                  <div class="labelItem f-c-c mb-2">وضعیت :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{ v.title }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.status }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100 mb-3"
          >
            کاربری وجود ندارد.
          </div>
        </div>

        <div v-if="profileChart.charts" class="f-c-s f-d-c w-100">
          <apexchart
            v-for="(v, i) in profileChart.charts"
            :key="i"
            :id="
              v.type == 'bar'
                ? 'chart'
                : v.type == 'line'
                ? 'chart2'
                : v.type == 'pie'
                ? 'chart3'
                : 'chart4'
            "
            width="500"
            :type="v.type"
            :options="v.options"
            :series="v.series"
          ></apexchart>
        </div>
      </div>
    </div>
    <div class="gapMaterial f-c-c w-100">
      <div class="text blueText f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
      </div>
    </div>
    <b-modal
      id="editPhoto-modal"
      title="برش عکس"
      button-size="sm"
      :hide-footer="footer"
      ref="editPhoto-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="cropPhoto">
          <vue-croppie
            ref="croppieRef"
            :enableResize="false"
            :enableOrientation="true"
            :boundary="{ width: 100, height: 100 }"
            :viewport="{ width: 100, height: 100, type: 'circle' }"
          >
          </vue-croppie>
          <div class="btnSection w-100 f-c-c">
            <button class="f-c-c" @click="crop">ثبت</button>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="edit-modal"
      title="افزودن سازمان جدید"
      button-size="sm"
      :hide-footer="footer"
      ref="addGroup-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-5 mt-3">
          <div class="label f-c-s w-f w-fit ml-3">سازمان</div>
          <v-select
            v-model="selectGroup"
            @input="setSelected"
            :title="organizationTitle"
            :options="organization.information"
            :reduce="(option) => option.id"
            label="title"
          />
          <!-- <select class="repeatPeriod" v-model="selectGroup">
            <option
              v-for="(g, j) in organization.information"
              :key="j"
              :value="g.id"
            >
              {{ g.title }}
            </option>
          </select> -->
        </div>
        <div class="btnSec w-100 f-c-c mb-3">
          <div
            class="finalbtn f-c-c mr-0"
            style="width: 250px"
            @click="saveGroupFunc()"
          >
            ذخیره
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Profile",
  data() {
    return {
      barKey: 0,
      lineKey: 0,
      pieKey: 0,
      radialBarKey: 0,
      currentPage4: 1,
      perPage4: 15,
      footer: true,
      croppieImage: "",
      cropped: null,
      headerTitle: "",
      selectGroup: "",
      organizationTitle: "",
      name: "",
      family: "",
      email: "",
      mobile: "",
      org: "",
      password: "",
      rpassword: "",
      gender: "",
      isShowPass: false,
      isShowRpass: false,
      genders: [
        { id: 1, name: "زن", value: "female" },
        { id: 2, name: "مرد", value: "male" },
        { id: 3, name: "هردو", value: "all" },
      ],
      recordList: [],
      mobileMyGroup: [],
      options4: {
        chart: {
          height: 350,
          offsetY: -10,
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: "16px",
                color: undefined,
                offsetY: 120,
              },
              value: {
                offsetY: 76,
                fontSize: "22px",
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                },
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91],
          },
        },
        stroke: {
          dashArray: 4,
        },
        labels: ["میزان رضایت"],
      },
      series4: [67],
    };
  },
  created() {
    this.getOrganizationFunction({
      user_id: 0,
    });
    this.getUserGroupsFunction({
      user_id: this.user.user_id,
    });
    this.getUserProfileFunction({
      user_id: this.user.user_id,
    });
    this.getProfileChartFunction({
      user_id: this.user.user_id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      userProfileData: (state) => state.gap.userProfileData,
      editUserProfileStatus: (state) => state.gap.editUserProfileStatus,
      organization: (state) => state.gap.organization,
      userGroups: (state) => state.gap.userGroups,
      userNewGroupStatus: (state) => state.gap.userNewGroupStatus,
      profileChart: (state) => state.gap.profileChart,
    }),
    rows4() {
      return this.recordList.length;
    },
    itemsForList4() {
      return this.recordList.slice(
        (this.currentPage4 - 1) * this.perPage4,
        this.currentPage4 * this.perPage4
      );
    },
  },
  components: {},
  methods: {
    ...mapActions("gap", [
      "getUserProfileFunction",
      "editUserProfileFunction",
      "getProfileChartFunction",
      "getUserGroupsFunction",
      "setUserNewGroupFunction",
      "getOrganizationFunction",
    ]),
    setSelected(v) {
      const result = this.organization.information.filter((a) => {
        return parseInt(a.id) == parseInt(v);
      });
      if (result[0]) {
        this.organizationTitle = result[0].title;
      } else {
        this.organizationTitle = "";
      }
    },
    addGroupFunc() {
      this.$refs["addGroup-modal"].show();
    },
    saveGroupFunc() {
      this.setUserNewGroupFunction({
        user_id: this.user.user_id,
        organ: this.selectGroup,
      });
      this.$refs["addGroup-modal"].hide();
    },
    editUserProfileFunc() {
      if (this.name == "" || this.name.length <= 2) {
        this.$bvToast.toast("نام خود را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.password != this.rpassword) {
        this.$bvToast.toast("پسورد و تکرار پسورد باهم برابر نیستند.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.family == "" || this.family.length <= 2) {
        this.$bvToast.toast("نام خانوادگی خود را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else {
        this.editUserProfileFunction({
          user_id: this.user.user_id,
          first_name: this.name,
          last_name: this.family,
          mobile: this.mobile,
          password: this.password,
          avatar: this.croppieImage,
        });
      }
    },
    showPasswordFunc() {
      this.isShowPass = !this.isShowPass;
    },
    showRpasswordFunc() {
      this.isShowRpass = !this.isShowRpass;
    },
    editUserPhotoFunc() {
      document.getElementById("getUserPhoto").click();
    },
    croppie(e) {
      this.$refs["editPhoto-modal"].show();
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
    },
    crop() {
      let options = {
        type: "base64",
        size: { width: 100, height: 100 },
        format: "png",
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = this.croppieImage = output;
      });
      this.$refs["editPhoto-modal"].hide();
    },
  },
  watch: {
    userGroups(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.recordList = n.user_organs;
          this.mobileMyGroup = n.user_organs;
        }
      }
    },
    userNewGroupStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.$bvToast.toast(n.message, {
            title: "ثبت",
            variant: "success",
            solid: true,
          });
          this.getUserGroupsFunction({
            user_id: this.user.user_id,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    editUserProfileStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 102) {
          this.getUserProfileFunction({
            user_id: this.user.user_id,
          });
          this.$bvToast.toast(n.message, {
            title: "ویرایش",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    userProfileData(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.cropped = n.avatar;
          this.headerTitle = n.fullname;
          this.name = n.first_name;
          this.family = n.last_name;
          this.email = n.email;
          this.mobile = n.mobile;
          this.gender = n.gender;
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
</style>